const getTranslations = ({ i18n }) => ({
  PREVIEW_TEXT: i18n.t`Preview`,
  DEFAULT_PREVIEW_ERROR_TEXT: i18n.t`Preview not available at this moment.`
});

export default getTranslations;



// WEBPACK FOOTER //
// ./components/learning-journey/translations.js